import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { CommentRootModel } from "@repo/structure";
import { COMPANY_SETTINGS } from "@client";
import { getCompanyRateCardQuery, getCompanySettingsQuery } from "@query";
import { PROJECT_TYPE } from "@utils";
import { EstimateCommentsProvider, EstimateEditorStore, EstimateEditorStoreProvider } from "@tools";
import { LibraryStore, LibraryStoreProvider } from "@views/Projects/Library/providers";
import { PageCircularProgress } from "@components";
import { LibraryView } from "./LibraryView";

export const Library = () => {
  
  const {t} = useTranslation();
  
  const [ store, setStore ] = useState(null);
  const [ libraryStore, setLibraryStore ] = useState(null);
  const commentStore = useMemo(() => CommentRootModel.create({ groups: [] }), []);
  
  useEffect(() => {
    document.title = `${t("routes.library")} - Apropo`;
  }, [])

  useEffect(() => {
    onLoad();
  }, []);

  const onLoad = async () => {
    const workTypes = await getCompanyRateCardQuery(true);
    const defaultCurrency = await getCompanySettingsQuery(COMPANY_SETTINGS.CURRENCY_DEF);

    setStore(new EstimateEditorStore({
      estimateType: PROJECT_TYPE.LIBRARY,
      workTypes,
      companySettings: {
        defaultCurrency
      }
    }));
    setLibraryStore(new LibraryStore({ defaultCurrency }));
  };
  
  return !store ? (
    <PageCircularProgress />
  ) : (
    <EstimateCommentsProvider value={commentStore}>
      <EstimateEditorStoreProvider value={store}>
        <LibraryStoreProvider value={libraryStore}>
          <LibraryView />
        </LibraryStoreProvider>
      </EstimateEditorStoreProvider>
    </EstimateCommentsProvider>
  );
};
